export const AI_COVER_LETTER = "ai_cover_letter_nextjs"
export const AI_COVER_LETTER_VARIANTS = {
  DISABLED: "feature_off",
  ENABLED: "feature_on",
}
